var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"container-custom",attrs:{"fluid":""}},[_c('img',{staticClass:"img-not-found",attrs:{"src":_vm.img,"alt":"test"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }